import { useEffect, useState } from "react";
import type { ServiceType } from "../DTOs/SundayService";
import { loadGemeindeSettings } from "../services/gemeindeSettingsService";
import { choirServiceTypesOf, DEFAULT_CHOIR_SERVICE_TYPES } from "../utils/serviceType";

/**
 * The Gemeinde's choir service types (setting `choirServiceTypes`, GOD-49).
 * Members may not read the settings document; they get the default.
 */
export function useChoirServiceTypes(gemeindeId: string | null, canReadSettings: boolean): ServiceType[] {
    const [types, setTypes] = useState<ServiceType[]>(DEFAULT_CHOIR_SERVICE_TYPES);
    useEffect(() => {
        if (!gemeindeId || !canReadSettings) return;
        let cancelled = false;
        loadGemeindeSettings(gemeindeId)
            .then((settings) => !cancelled && setTypes(choirServiceTypesOf(settings.choirServiceTypes)))
            .catch(() => undefined);
        return () => {
            cancelled = true;
        };
    }, [gemeindeId, canReadSettings]);
    return types;
}
